
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLoading = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.974 16.727a.8.8 0 0 0 1.132-.188l.045-.073 1.801-3.3a.8.8 0 0 0-1.404-.766l-.855 1.567a6.546 6.546 0 0 1 3.622-7.964 6.503 6.503 0 0 1 5.416.092.8.8 0 1 0 .689-1.444 8.1 8.1 0 0 0-6.742-.116c-3.728 1.625-5.624 5.712-4.62 9.53l-1.16-.854a.801.801 0 0 0-.949 1.29l3.025 2.226Zm14.064-9.535a.798.798 0 0 0-1.13.188l-.044.073-1.852 3.392a.8.8 0 1 0 1.404.767l.86-1.578A6.545 6.545 0 0 1 14.655 18a6.503 6.503 0 0 1-5.416-.092.8.8 0 1 0-.689 1.444 8.1 8.1 0 0 0 6.742.116c3.776-1.646 5.671-5.817 4.578-9.677l1.331.98a.8.8 0 0 0 .949-1.29l-3.112-2.288Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.97445 16.7272C5.16028 16.8639 5.39663 16.9139 5.62191 16.8639C5.81921 16.82 5.99216 16.7031 6.10628 16.5387L6.15121 16.4664L7.95199 13.1666C8.16344 12.7788 8.02098 12.2933 7.63363 12.0817C7.246 11.8701 6.75952 12.0122 6.54769 12.4L5.6932 13.9674C4.69605 10.8131 6.22144 7.35142 9.31527 6.00255C11.1188 5.21631 13.0825 5.30889 14.7313 6.09533C15.1296 6.28535 15.6072 6.11696 15.7977 5.71837C15.988 5.31933 15.8183 4.84111 15.4198 4.65099C13.3711 3.67389 10.9238 3.55554 8.67758 4.53478C4.94964 6.16008 3.05353 10.2469 4.05746 14.0651L2.89828 13.2115C2.54251 12.9499 2.041 13.0274 1.77914 13.3834C1.51754 13.7394 1.5935 14.2399 1.94906 14.5016L4.97445 16.7272ZM19.0384 7.19174C18.8528 7.05547 18.6178 7.00621 18.3929 7.056C18.1957 7.09985 18.0227 7.21596 17.9085 7.38022L17.8636 7.45346L16.012 10.8451C15.8004 11.233 15.9428 11.7195 16.3304 11.931C16.718 12.1424 17.2046 11.9995 17.4163 11.6117L18.2757 10.0345C19.2732 13.1889 17.7485 16.6504 14.6546 17.9994C12.8511 18.7856 10.8874 18.693 9.23861 17.9066C8.8403 17.7166 8.36271 17.885 8.17221 18.2835C7.98193 18.6826 8.1516 19.1608 8.55014 19.3509C10.5988 20.328 13.046 20.4464 15.2923 19.4671C19.0682 17.8209 20.963 13.6501 19.8704 9.79037L21.2015 10.7699C21.5572 11.0314 22.0578 10.9547 22.3197 10.599C22.5815 10.243 22.5053 9.74259 22.1497 9.4808L19.0384 7.19174Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-loading.607a65c2208172db1e66bb2ea8d252ed.svg"),
        {
          React: SvgIconLoading,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      